import React, { Suspense } from "react";

// import { Container } from './styles';
interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => (
  <Suspense fallback={<h1>Carregando!</h1>}>
    <div className="App" style={{ overflowX: "hidden" }}>{children}</div>
  </Suspense>
);

export default Layout;
